import { ContentTypeEnum } from './content-type.enum';

export class ContentTypeItem {
    title: string;
    description: string;
    value: number;
    svgIcon: string;
}

export class ContentType {
    static all: ContentTypeItem[] = [
        {
            title: 'CONTENT_TYPE.POSTING.TITLE',
            description: 'CONTENT_TYPE.POSTING.DESCRIPTION',
            value: ContentTypeEnum.Posting,
            svgIcon: 'content_posting',
        },
        {
            title: 'CONTENT_TYPE.ARTICLE.TITLE',
            description: 'CONTENT_TYPE.ARTICLE.DESCRIPTION',
            value: ContentTypeEnum.Article,
            svgIcon: 'content_article',
        },
        {
            title: 'CONTENT_TYPE.COURSE.TITLE',
            description: 'CONTENT_TYPE.COURSE.DESCRIPTION',
            value: ContentTypeEnum.Course,
            svgIcon: 'content_course',
        },
        {
            title: 'CONTENT_TYPE.CATEGORY.TITLE',
            description: 'CONTENT_TYPE.CATEGORY.DESCRIPTION',
            value: ContentTypeEnum.Category,
            svgIcon: 'content_category',
        },
        {
            title: 'CONTENT_TYPE.LIVE_LINK.TITLE',
            description: 'CONTENT_TYPE.LIVE_LINK.DESCRIPTION',
            value: ContentTypeEnum.Live_Link,
            svgIcon: 'content_live_link',
        },
    ];
}
